"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAppInitializer = void 0;
const translations_1 = require("../../translations");
const uiInformation_1 = require("../../uiInformation");
const tracker_1 = require("../../tracker");
const featureFlag_1 = require("../../featureFlag");
// types
const initializer_1 = require("../../initializer");
const libraries_1 = require("../../libraries");
// eslint-disable-next-line complexity
const subAppInitializer = async ({ API, libraries = [], trackerConfig, featureFlagConfig, translationsConfig, setGlobalEventBus }, data) => {
    initializer_1.Session.finishSession();
    initializer_1.Session.initSession(data.sessionData);
    if (trackerConfig) {
        await (0, tracker_1.initAllTrackers)(trackerConfig, API, initializer_1.GenericUSDManager, initializer_1.Authenticator);
        tracker_1.trackers.tealiumTracker && (0, tracker_1.addCommonInfoToTealiumTracker)(trackerConfig);
        tracker_1.trackers.wrapupTracker && (0, tracker_1.addCommonInfoToWrapupTracker)(trackerConfig);
    }
    data.eventBus && setGlobalEventBus && setGlobalEventBus(data.eventBus);
    try {
        const featureAndTranslationsPromises = [];
        if (featureFlagConfig) {
            featureAndTranslationsPromises.push((0, featureFlag_1.initFeatureFlag)(featureFlagConfig, API));
        }
        if (translationsConfig) {
            featureAndTranslationsPromises.push((0, translations_1.initConfigWebAndOwnTranslations)(API, translationsConfig));
        }
        await Promise.allSettled(featureAndTranslationsPromises);
    }
    catch {
        console.error('Can`t initiate feature flag or translations. Check network');
    }
    const libAndDevicePromises = [];
    libAndDevicePromises.push((0, libraries_1.initLibraries)(libraries));
    libAndDevicePromises.push((0, uiInformation_1.initDeviceUUID)());
    try {
        await Promise.all(libAndDevicePromises);
    }
    catch (error) {
        console.error(error);
        console.error('Can`t initiate feature flag or translations. Check network');
    }
};
exports.subAppInitializer = subAppInitializer;
//# sourceMappingURL=initializers.js.map